"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = require("lodash");

var _cookiesJs = _interopRequireDefault(require("cookies-js"));

var _withMainControls = _interopRequireDefault(require("eventbrite_design_system/structure/hoc/withMainControls"));

var _constants = require("eventbrite_design_system/notification/constants");

var _constants2 = require("../constants");

var _AlertChunky = _interopRequireDefault(require("eventbrite_design_system/iconography/icons/AlertChunky"));

var _CheckChunky = _interopRequireDefault(require("eventbrite_design_system/iconography/icons/CheckChunky"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
This is an HoC that should be utilized with applications that implement
save/unsave functionality for events. It should be wrapped at a high level
such that isAuthenticated and an onSave can be passed as props.

In the case of a logged out save and then follow up redirect back, it will
parse the cookie and attempt to call the passed in save action and then display
a notification that the event was successfully saved.

Additionally it passed down a prop to display an already configured success or
error notification for the event save action.
*/
var withEventSaveNotification = function withEventSaveNotification(Component) {
  var _class, _temp;

  return (0, _withMainControls.default)((_temp = _class = /*#__PURE__*/function (_React$PureComponent) {
    _inherits(LoggedOutEventSaveRedirect, _React$PureComponent);

    var _super = _createSuper(LoggedOutEventSaveRedirect);

    function LoggedOutEventSaveRedirect() {
      var _this;

      _classCallCheck(this, LoggedOutEventSaveRedirect);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this), "_handleShowSaveNotification", function (status) {
        var isRedirect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var _this$props = _this.props,
            addMainNotification = _this$props.addMainNotification,
            hideMainNotification = _this$props.hideMainNotification;
        var notificationInfo = {
          type: _constants.TYPE_ERROR,
          children: _constants2.EVENT_SAVE_ERROR,
          iconType: /*#__PURE__*/_react.default.createElement(_AlertChunky.default, null),
          isNotificationSticky: true
        };

        if (status === 'success') {
          notificationInfo = {
            children: _constants2.EVENT_SAVE,
            iconType: /*#__PURE__*/_react.default.createElement(_CheckChunky.default, null),
            isNotificationSticky: true
          };
        } //Only show notification if an error, or user save
        //was successful after log-in redirect


        if (status !== 'success' || status === 'success' && isRedirect) {
          addMainNotification(notificationInfo);
          (0, _lodash.delay)(hideMainNotification, 7000);
        }
      });

      return _this;
    }

    _createClass(LoggedOutEventSaveRedirect, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this2 = this;

        var _this$props2 = this.props,
            isAuthenticated = _this$props2.isAuthenticated,
            onSaveEvent = _this$props2.onSaveEvent;

        var eventIdFromCookie = _cookiesJs.default.get(_constants2.EVENT_COOKIE);

        if (eventIdFromCookie && isAuthenticated) {
          onSaveEvent(eventIdFromCookie, true, {}, false).then(function (status) {
            _this2._handleShowSaveNotification(status, true);
          }).catch(function () {
            _this2._handleShowSaveNotification('error', true);
          });

          _cookiesJs.default.expire(_constants2.EVENT_COOKIE);
        }
      }
      /*
      @param status {string} oneOf(['success', 'error'])
      @param isRedirect {bool}
      */

    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react.default.createElement(Component, this.props);
      }
    }]);

    return LoggedOutEventSaveRedirect;
  }(_react.default.PureComponent), _defineProperty(_class, "propTypes", {
    /*
    Function that will be called if user is redirected back
    and we need to trigger the save action
    */
    onSaveEvent: _propTypes.default.func.isRequired,

    /*
    Needed to determine if possible to call save event
    callback
    */
    isAuthenticated: _propTypes.default.bool.isRequired
  }), _temp));
};

var _default = withEventSaveNotification;
exports.default = _default;
//# sourceMappingURL=withEventSaveNotification.js.map